"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCvSourceSuggestions = exports.geocodeByPlaceId = exports.getPlaceSuggestions = exports.searchEmployees = exports.externGetAtheneumContacts = exports.getAtheneumContactSuggestions = exports.getClientContactSuggestions = exports.getClientSuggestions = exports.getParentAccountSuggestions = exports.getAccountSuggestions = exports.getProjectSuggestions = exports.getOfficeSuggestions = exports.getPositionSuggestions = exports.getCompanySuggestions = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
function getCompanySuggestions(companyString) {
    var encodedCompanyString = encodeURIComponent(companyString);
    return api_1.default.get("/api/company/typeahead?q=".concat(encodedCompanyString)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getCompanySuggestions = getCompanySuggestions;
function getPositionSuggestions(positionString, limit) {
    var encodedPositionString = encodeURIComponent(positionString);
    var baseUrl = "/api/typeahead/positions?q=".concat(encodedPositionString);
    if (limit) {
        baseUrl = baseUrl + "&limit=".concat(limit);
    }
    return api_1.default.get(baseUrl).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getPositionSuggestions = getPositionSuggestions;
function getOfficeSuggestions(searchString, _a) {
    var parentAccountId = _a.parentAccountId, projectId = _a.projectId;
    var payload = { searchString: searchString, projectId: projectId, parentAccountId: parentAccountId, limit: 50 };
    return api_1.default.post('/api/office/typeahead-search', payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getOfficeSuggestions = getOfficeSuggestions;
function getProjectSuggestions(projectString) {
    var encodedProjectString = encodeURIComponent(projectString);
    return api_1.default
        .get("/api/project/typeahead?q=".concat(encodedProjectString, "&open=true&pending=true"))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getProjectSuggestions = getProjectSuggestions;
function getAccountSuggestions(accountString) {
    var encodedAccountString = encodeURIComponent(accountString);
    return api_1.default.get("/api/account/typeahead?q=".concat(encodedAccountString)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getAccountSuggestions = getAccountSuggestions;
function getParentAccountSuggestions(parentAccountString) {
    var encodedParentAccountString = encodeURIComponent(parentAccountString);
    return api_1.default
        .get("/api/parent-account/typeahead-search?q=".concat(encodedParentAccountString))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getParentAccountSuggestions = getParentAccountSuggestions;
function getClientSuggestions(parentAccountId, clientString) {
    var encodedClientString = encodeURIComponent(clientString);
    return api_1.default
        .get("/api/client/typeahead-search?q=".concat(encodedClientString, "&parentAccountId=").concat(parentAccountId))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getClientSuggestions = getClientSuggestions;
function getClientContactSuggestions(clientContactString, options) {
    if (options === void 0) { options = {}; }
    var encodedClientContactString = encodeURIComponent(clientContactString);
    var query = "?q=".concat(encodedClientContactString);
    if (options.limit) {
        query = query + "&limit=".concat(options.limit);
    }
    if (options.parentAccountId) {
        query = query + "&parentAccountId=".concat(options.parentAccountId);
    }
    return api_1.default.get("/api/client/typeahead-search".concat(query)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getClientContactSuggestions = getClientContactSuggestions;
function getAtheneumContactSuggestions(atheneumContactString, options) {
    var encodedAtheneumContactString = encodeURIComponent(atheneumContactString);
    var url = "/api/employee?query=".concat(encodedAtheneumContactString);
    if (options) {
        var params = query_string_1.default.stringify(options);
        url = url + '&' + params;
    }
    return api_1.default.get(url).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getAtheneumContactSuggestions = getAtheneumContactSuggestions;
function externGetAtheneumContacts(query) {
    var encoded = encodeURIComponent(query);
    var url = "/api/employee/extern-typeahead?q=".concat(encoded);
    return api_1.default.get(url).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.externGetAtheneumContacts = externGetAtheneumContacts;
function searchEmployees(options) {
    var params = query_string_1.default.stringify(options);
    var url = "/api/employee/search?".concat(params);
    return api_1.default.get(url).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.searchEmployees = searchEmployees;
function getPlaceSuggestions(placeString, types) {
    var encodedPlaceString = encodeURIComponent(placeString);
    return api_1.default
        .get("/api/googleplaces/autocomplete-places?input=".concat(encodedPlaceString, "&types=").concat(types))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getPlaceSuggestions = getPlaceSuggestions;
function geocodeByPlaceId(placeId) {
    return api_1.default.get("/api/googleplaces/geocode-by-placeid?placeId=".concat(placeId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.geocodeByPlaceId = geocodeByPlaceId;
function getCvSourceSuggestions(cvSourceString) {
    var encodedCvSourceString = encodeURIComponent(cvSourceString);
    return api_1.default.get("/api/cv-source/typeahead?q=".concat(encodedCvSourceString)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getCvSourceSuggestions = getCvSourceSuggestions;
var api = {
    getCompanySuggestions: getCompanySuggestions,
    getPositionSuggestions: getPositionSuggestions,
    getOfficeSuggestions: getOfficeSuggestions,
    getProjectSuggestions: getProjectSuggestions,
    getAccountSuggestions: getAccountSuggestions,
    getParentAccountSuggestions: getParentAccountSuggestions,
    getClientSuggestions: getClientSuggestions,
    getClientContactSuggestions: getClientContactSuggestions,
    getAtheneumContactSuggestions: getAtheneumContactSuggestions,
    searchEmployees: searchEmployees,
    getPlaceSuggestions: getPlaceSuggestions,
    geocodeByPlaceId: geocodeByPlaceId,
};
exports.default = api;
